<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] TextField" />

    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Text Field [S] -->
      <div class="comm_title_wrap">
        <h3>Text Field</h3>
      </div>

      <div class="comm_view_wrap">
        <!-- (1) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field v-model="sampleDefault" />
          </div>
          <div class="col-xs-6">
            <span class="info">// default text field (empty)</span>
          </div>
        </div>

        <!-- (2) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="samplePassword"
              password
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// password</span>
          </div>
        </div>

        <!-- (3) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="sampleSearchWord"
              fixedIcon
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// 검색아이콘</span>
          </div>
        </div>

        <!-- (3-1) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="sampleSearchWord"
              fixedIcon
              disabled
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// 검색아이콘 (disabled)</span>
          </div>
        </div>

        <!-- (3-2) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="sampleSearchWord"
              fixedIcon
              readonly
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// 검색아이콘 (readonly)</span>
          </div>
        </div>

        <!-- (4) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="sampleDisabled"
              disabled
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// disabled</span>
          </div>
        </div>

        <!-- (5) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="sampleReadonly"
              readonly
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// readonly</span>
          </div>
        </div>

        <!-- (6) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="sampleMaxlength"
              maxlength="5"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// max length (5)</span>
          </div>
        </div>
      <!-- Text Field [E] -->
      </div>

      <div class="comm_title_wrap">
        <h3>With Masking</h3>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="날짜 2019-01-01" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="sampleCurrency3"
            mask="date"
            placeholder="날짜입력"
          />
        </div>
        <div class="col-xs-6">
          <span class="info">// mask = "####-##-##"</span>&nbsp;&nbsp;
          <span class="info caution">{{ sampleCurrency3 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="날짜 2019/01/01" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="sampleCurrency3"
            mask="####/##/##"
            placeholder="날짜입력"
          />
        </div>
        <div class="col-xs-6">
          <span class="info">// mask = "####/##/##"</span>&nbsp;&nbsp;
          <span class="info caution">{{ sampleCurrency3 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="한글,영어,숫자" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="maskSample1"
            mask="ken"
            placeholder="한글, 영어, 숫자"
          />
        </div>
        <div class="col-xs-6">
          <span class="info">// mask = "ken", 한글영어숫자 만 입력</span>&nbsp;&nbsp;
          <span class="info caution">{{ maskSample1 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="숫자,대문자,_ (8글자)" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="maskSample1"
            mask="UUUUUUUU"
            placeholder="숫자,대문자,_ (8글자) 입력"
          />
        </div>
        <div class="col-xs-6">
          <span class="info">// mask="UUUUUUUU", 숫자,대문자,_ (8글자) 만 입력</span>&nbsp;&nbsp;
          <span class="info caution">{{ maskSample1 }}</span>
        </div>
      </div>

      <div class="comm_title_wrap">
        <h3>With Masking (개인환경설정 적용)</h3>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="통화" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="sampleCurrency1"
            mask="currency"
            placeholder="통화 입력"
          />
        </div>
        <!-- placeholder는 Form입력 항목 타이틀 + "입력" -->
        <div class="col-xs-6">
          <span class="info">// currency, only number</span>&nbsp;&nbsp;
          <span class="info caution">{{ sampleCurrency1 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="통화" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="sampleCurrency2"
            mask="currency"
            placeholder="통화 입력"
            readonly
          />
        </div>
        <!-- placeholder는 Form입력 항목 타이틀 + "입력" -->
        <div class="col-xs-6">
          <span class="info">// currency, only number, (readonly는 좌측정렬)</span>&nbsp;&nbsp;
          <span class="info caution">{{ sampleCurrency2 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="통화" />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="sampleCurrency2"
            mask="currency"
            placeholder="통화 입력"
            disabled
          />
        </div>
        <!-- placeholder는 Form입력 항목 타이틀 + "입력" -->
        <div class="col-xs-6">
          <span class="info">// currency, only number, (disabled는 우측정렬)</span>&nbsp;&nbsp;
          <span class="info caution">{{ sampleCurrency2 }}</span>
        </div>
      </div>

      <div class="comm_title_wrap">
        <h3>With Validation</h3>
      </div>

      <div class="comm_view_wrap">
        <!-- With Validation [S] -->
        <!-- (7) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <fdp-validator
              v-model="sampleValidation1"
              name="validator1"
              :rules="sampleValidationRule1"
            >
              <sui-text-field
                v-model="sampleValidation1"
              />
            </fdp-validator>
          </div>
          <div class="col-xs-6">
            <span class="info">// required, email</span>
            <span class="info caution">{{ sampleValidation1 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-text-field>" />
          </div>
          <div class="col-xs-5">
            <fdp-validator
              v-model="sampleValidation2"
              name="validator2"
              :rules="sampleValidationRule2"
            >
              <sui-text-field
                ref="test1"
                v-model="sampleValidation2"
                @blur="onInputBlurred"
              />
            </fdp-validator>
          </div>
          <div class="col-xs-6">
            <span class="info">// validation,</span>
            <span class="info caution">isValid = {{ customCode }}</span>
            <button
              type="button"
              class="comm_btn_Scr"
              @click="onClick"
            >
              invalid로 변경
            </button>
          </div>
        </div>

        <!-- With Validation [E] -->
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'CompGuideTextField',
  data() {
    return {
      sampleDefault: '',
      samplePassword: '',
      sampleSearchWord: '',
      sampleDisabled: '',
      sampleReadonly: '',
      sampleMaxlength: '',
      sampleValidation1: '',
      sampleValidation2: 'Hi, Hi !',
      sampleCurrency1: '',
      sampleCurrency2: '3333333',
      sampleCurrency3: '20190930',
      maskSample1: '',
      customCode: false,
      customMessage: 'Error',

      // valid 체크할 element
      sampleInput1: null,
    };
  },
  computed: {
    sampleValidationRule1() {
      return {
        required: true, // required 에러와 함께 사용하면 빈값 검증 가능.
        email: true,
      };
    },

    sampleValidationRule2() {
      return {
        sui_custom: [
          this.customCode, // 패스여부(false일 때 에러)
          this.customMessage, // 에러 메시지
        ],
      };
    },
  },
  watch: {},
  datasets: [],
  mounted() {
    this.sampleInput1 = this.$refs.test1.$refs.refInput;
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onClick() {
      // 이해하기 쉽게 패스 사항 처리.
      // valid 한 상황에 대한 처리를 하고, customCode 를 true/false로 설정하면 된다.
      this.setValidCode(false);
    },

    setValidCode(isValid) {
      this.customCode = isValid;
    },

    onInputBlurred() {
      const { value } = this.sampleInput1;
      console.log('onInputBlurred', value);
      this.setValidCode(true);
    },
  },
};
</script>

<style scoped>
</style>
